import { Industry } from '@/enums';

export interface IndustryColorTheme {
  button: {
    start: string;
    end: string;
  };
  progressBar: {
    start: string;
    end: string;
  };
  background: {
    start: string;
    end: string;
  };
  hamburger: {
    color: string;
    colorHover: string;
    bgHover: string;
  };
  score: string;
  resultAbout: {
    color: string;
    bgColor: string;
  };
  resultCircle: {
    colorCenter: string;
    colorElse: string;
    bgCenter: string;
    bgElse: string;
  };
}

export const industryColorThemes: Record<Industry, IndustryColorTheme> = {
  [Industry.Restaurant]: {
    button: {
      start: '#f1e3c0',
      end: '#f3c10acc',
    },
    progressBar: {
      start: '#f3c10acc',
      end: '#f1e3c0',
    },
    background: {
      start: '#f2f2f2',
      end: '#f3c10acc',
    },
    hamburger: {
      color: '#7f5e00',
      colorHover: '#000000',
      bgHover: '#f3c10a',
    },
    score: '#f3c10a',
    resultAbout: {
      color: '#000000',
      bgColor: '#f3c10a',
    },
    resultCircle: {
      colorCenter: '#000000',
      colorElse: '#000000',
      bgCenter: '#f3c10a',
      bgElse: '#cc9b00',
    },
  },
  [Industry.CraftsAndAgriculturalProcessing]: {
    button: {
      start: '#ff5a00',
      end: '#f3b6a1cc',
    },
    progressBar: {
      start: '#f3b6a1cc',
      end: '#ff5a00',
    },
    background: {
      start: '#ffffff',
      end: '#ffa470',
    },
    hamburger: {
      color: '#ff5a00',
      colorHover: '#ffffff',
      bgHover: '#ff5a00',
    },
    score: '#ff5a00',
    resultAbout: {
      color: '#ffffff',
      bgColor: '#ff7936',
    },
    resultCircle: {
      colorCenter: '#ffffff',
      colorElse: '#ffffff',
      bgCenter: '#ff7936',
      bgElse: '#ff5a00',
    },
  },
  [Industry.TourismAndAccommodation]: {
    button: {
      start: '#146293',
      end: '#b3b3b3cc',
    },
    progressBar: {
      start: '#b3b3b3cc',
      end: '#146293',
    },
    background: {
      start: '#fafafa',
      end: '#7895a7cc',
    },
    hamburger: {
      color: '#146293',
      colorHover: '#ffffff',
      bgHover: '#146293',
    },
    score: '#146293',
    resultAbout: {
      color: '#ffffff',
      bgColor: '#146293',
    },
    resultCircle: {
      colorCenter: '#ffffff',
      colorElse: '#ffffff',
      bgCenter: '#146293',
      bgElse: '#033954',
    },
  },
  [Industry.ExperienceActivitiesAndSightseeing]: {
    button: {
      start: '#e6e6e6',
      end: '#af803dcc',
    },
    progressBar: {
      start: '#af803dcc',
      end: '#e6e6e6',
    },
    background: {
      start: '#e6e6e6',
      end: '#d69855cc',
    },
    hamburger: {
      color: '#c17b34',
      colorHover: '#000000',
      bgHover: '#c17b34',
    },
    score: '#c17b34',
    resultAbout: {
      color: '#000000',
      bgColor: '#c17b34',
    },
    resultCircle: {
      colorCenter: '#000000',
      colorElse: '#ffffff',
      bgCenter: '#c17b34',
      bgElse: '#84460f',
    },
  },
  [Industry.Agriculture]: {
    button: {
      start: '#af803d',
      end: '#68a376cc',
    },
    progressBar: {
      start: '#68a376cc',
      end: '#af803d',
    },
    background: {
      start: '#f2f2f2',
      end: '#b1d0b7cc',
    },
    hamburger: {
      color: '#4e895f',
      colorHover: '#ffffff',
      bgHover: '#4e895f',
    },
    score: '#4e895f',
    resultAbout: {
      color: '#ffffff',
      bgColor: '#4e895f',
    },
    resultCircle: {
      colorCenter: '#ffffff',
      colorElse: '#ffffff',
      bgCenter: '#4e895f',
      bgElse: '#30603d',
    },
  },
  [Industry.AnimalHusbandry]: {
    button: {
      start: '#2a899a',
      end: '#e5d37bcc',
    },
    progressBar: {
      start: '#e5d37bcc',
      end: '#2a899a',
    },
    background: {
      start: '#f2f2f2',
      end: '#b1d0b7cc',
    },
    hamburger: {
      color: '#2a899a',
      colorHover: '#ffffff',
      bgHover: '#2a899a',
    },
    score: '#2a899a',
    resultAbout: {
      color: '#ffffff',
      bgColor: '#2e899a',
    },
    resultCircle: {
      colorCenter: '#ffffff',
      colorElse: '#ffffff',
      bgCenter: '#2e899a',
      bgElse: '#0a545b',
    },
  },
  [Industry.DevelopmentAssociationAndCommunity]: {
    button: {
      start: '#ae7778',
      end: '#e6e6e6cc',
    },
    progressBar: {
      start: '#e6e6e6cc',
      end: '#ae7778',
    },
    background: {
      start: '#e6e6e6',
      end: '#cfb9b9cc',
    },
    hamburger: {
      color: '#ae7778',
      colorHover: '#ffffff',
      bgHover: '#ae7778',
    },
    score: '#ae7778',
    resultAbout: {
      color: '#ffffff',
      bgColor: '#ae7778',
    },
    resultCircle: {
      colorCenter: '#ffffff',
      colorElse: '#ffffff',
      bgCenter: '#ae7778',
      bgElse: '#7c4a4d',
    },
  },
};

export const getIndustryColorTheme = (
  industry?: Industry,
): IndustryColorTheme => {
  return industry
    ? industryColorThemes[industry]
    : {
        button: {
          start: '#af803d',
          end: '#68a376cc',
        },
        progressBar: {
          start: '#68a376cc',
          end: '#af803d',
        },
        background: {
          start: '#f2f2f2',
          end: '#b1d0b7cc',
        },
        hamburger: {
          color: '#59824b',
          colorHover: '#ffffff',
          bgHover: '#59824b',
        },
        score: '#75a17a',
        resultAbout: {
          color: 'transparent',
          bgColor: 'transparent',
        },
        resultCircle: {
          colorCenter: 'transparent',
          colorElse: 'transparent',
          bgCenter: 'transparent',
          bgElse: 'transparent',
        },
      };
};

export const createGradient = (start: string, end: string): string => {
  return `linear-gradient(${start} 0%, ${end} 100%)`;
};

// Helper function to get background gradient based on industry
export const getIndustryBackgroundGradient = (industry: Industry): string => {
  const theme = getIndustryColorTheme(industry);
  return createGradient(theme.background.start, theme.background.end);
};

// Helper function to get NextButton gradient based on industry
export const getIndustryButtonGradient = (industry: Industry): string => {
  const theme = getIndustryColorTheme(industry);
  return createGradient(theme.button.start, theme.button.end);
};

// Helper function to get ProgressBar gradient based on industry
export const getIndustryProgressGradient = (industry: Industry): string => {
  const theme = getIndustryColorTheme(industry);
  return createGradient(theme.progressBar.start, theme.progressBar.end);
};

// Helper function to get Hamburger color based on industry
export const getIndustryHamburgerColor = (
  industry?: Industry,
): IndustryColorTheme['hamburger'] => {
  const theme = getIndustryColorTheme(industry);
  return theme.hamburger;
};

// Helper function to get Score color based on industry
export const getIndustryScoreColor = (industry: Industry): string => {
  const theme = getIndustryColorTheme(industry);
  return theme.score;
};

// Helper function to get Result About colors based on industry
export const getIndustryResultAboutColors = (
  industry: Industry,
): IndustryColorTheme['resultAbout'] => {
  const theme = getIndustryColorTheme(industry);
  return theme.resultAbout;
};

// Helper function to get Result Circle colors based on industry
export const getIndustryResultCircleColors = (
  industry: Industry,
): IndustryColorTheme['resultCircle'] => {
  const theme = getIndustryColorTheme(industry);
  return theme.resultCircle;
};
